<template>
  <div class="reports standard">

    <!-- Search -->
    <div class="search" v-loading="loading">
      <h1>Standard Grouping Reports</h1>
      <p>Select one of the following prepared standard grouping reports.<br>
      You can also prepare a <router-link :to="{path: '/reports/custom-grouping'}">Custom Grouping Report</router-link></p>
      <el-alert v-if="alertTitle !== ''"
        :title="alertTitle"
        :type="alertType"
        :description="callInfo"
        :closable="false"
        show-icon>
      </el-alert>
      <el-table :data="tableData">
        <el-table-column prop="report" label="Report Name">
          <template slot-scope="props">
            <strong><a href="#" @click.prevent="getReports(props.row.report, null, props.row.label)">PEAs by {{ props.row.label ? props.row.label : capitalize(props.row.report) }}</a></strong><br>
            <el-button size="small" @click="props.row.showFilters = !props.row.showFilters">
              Filter Report
              <i v-if="!props.row.showFilters" class="el-icon-circle-plus"></i>
              <i v-else class="el-icon-remove"></i>
            </el-button>
            <div v-if="props.row.showFilters" class="filters">
              <div v-for="(filter, key) in props.row.filters" :key="key" class="filtersColumn">
                <strong>{{ capitalize(key) }}</strong>
                <ul>
                  <li v-for="(item, index) in filter" :key="index">
                    <el-radio v-model="selectedFilter" :label="key + ': ' + (item.name || item.description)" @change="getReports(props.row.report, key + ':' + (item.id ? item.id : item.name), props.row.label)">{{ item.name || item.description }}</el-radio>
                  </li>
                </ul>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="Report Description"></el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'standardGroupingReports',
  data () {
    return {
      departmentList: [],
      reasonList: [
        {name: 'Cost Reduction'},
        {name: 'Growth'},
        {name: 'Maintenance'},
        {name: 'Regulatory Compliance'},
        {name: 'Sustain'}
      ],
      statusList: [],
      selectedFilter: null,
      loading: false,
      reports: null,
      reportType: null,
      reportLabel: null,
      callInfo: '',
      alertType: '',
      alertTitle: ''
    }
  },
  computed: {
    tableData: function () {
      var data = [
        {
          report: 'status',
          description: 'Shows PEAs grouped by their current status (In Preparation, Raised, Approved, etc.)',
          filters: {
            department: this.departmentList,
            reason: this.reasonList
          },
          showFilters: false
        },
        {
          report: 'department',
          description: 'Shows PEAs grouped by their department',
          filters: {
            status: this.statusList,
            reason: this.reasonList
          },
          showFilters: false
        },
        {
          report: 'reason',
          description: 'Shows PEAs grouped by the reason field',
          filters: {
            status: this.statusList,
            department: this.departmentList
          },
          showFilters: false
        },
        {
          report: 'cost',
          label: 'Value Band',
          description: 'Shows PEAs grouped by the value band that they fall into',
          filters: {
            status: this.statusList,
            department: this.departmentList,
            reason: this.reasonList
          },
          showFilters: false
        },
        {
          report: 'approveTime',
          label: 'Time to Approve',
          description: 'Shows PEAs by time taken to approve',
          filters: {
            status: this.statusList,
            department: this.departmentList,
            reason: this.reasonList
          },
          showFilters: false
        },
        {
          report: 'projectEndDate',
          label: 'Project End Date',
          description: 'Shows PEAs by Project End Date',
          filters: {
            status: this.statusList,
            department: this.departmentList,
            reason: this.reasonList
          },
          showFilters: false
        },
        {
          report: 'owner',
          description: 'Shows PEAs grouped by the person who raised them',
          filters: {
            status: this.statusList,
            department: this.departmentList,
            reason: this.reasonList
          },
          showFilters: false
        },
        {
          report: 'urgency',
          description: 'Shows PEAs grouped by whether they are urgent or not',
          filters: {
            status: this.statusList,
            department: this.departmentList,
            reason: this.reasonList
          },
          showFilters: false
        },
        {
          report: 'variance',
          label: 'Variance Band',
          description: 'Shows PEAs grouped by their Spending Variance Band. The spending variance for a PEA is the amount that the final spending varied from the estimated cost when the PEA was raised.',
          filters: {
            status: this.statusList,
            department: this.departmentList,
            reason: this.reasonList
          },
          showFilters: false
        },
        {
          report: 'variance,owner',
          label: 'Variance Band and Owner',
          description: 'Shows PEAs grouped by their Spending Variance Band and then by who raised the PEA.  The spending variance for a PEA is the amount that the final spending varied from the estimated cost when the PEA was raised.',
          filters: {
            status: this.statusList,
            department: this.departmentList,
            reason: this.reasonList
          },
          showFilters: false
        }
      ]
      return data
    }
  },
  methods: {
    getLists: function () {
      this.$axios.get('/getDepartmentList').then(response => {
        this.departmentList = response.data
      }).catch(reject => {
        helperMethods.showNotification(this, 'Error getting Departments', reject.body, 'error', 30000, '')
      })
      this.statusList = JSON.parse(window.sessionStorage.statusList)
    },
    capitalize: function (input) {
      return input.charAt(0).toUpperCase() + input.slice(1)
    },
    getReports: function (type, filter = null, label = null) {
      var data = {
        groupBy: type,
        filter: filter || '',
        label: label || ''
      }
      if (label) {
        this.reportLabel = label
      }
      this.$router.push({path: '/report/' + 'groupBy=' + data.groupBy + '&filter=' + data.filter + '&label=' + data.label})
    },
    handleFilter: function (input) {
      this.getReports(input.report, input.filter)
    }
  },
  created: function () {
    this.getLists()
  }
}
</script>

<style lang="css" scoped>
  .el-table strong {
    font-size: 1.2em;
    margin-bottom: -10px;
    display: block;
  }

  .el-button {
    margin-right: 10px;
  }

  .filters {
    margin-top: 10px;
  }

  .filtersColumn {
    float: left;
    margin-right: 10px;
  }

  ul {
    padding: 0;
    margin-top: 15px;
  }

  li {
    list-style: none;
    padding: 0;
  }

  .pea-panel .groupInfo {
    margin-top: -20px;
  }
</style>

<style>

.el-badge.large .el-badge__content {
  font-size: 18px;
  padding-top: 1px;
  padding-bottom: 1px;
  line-height: normal;
  height: auto;
  border-radius: 100px;
  right: 0;
}

.group {
  position: relative;
  margin-bottom: 20px;
}

.groupInfo strong:not(:first-child) {
  margin-left: 30px;
}

.group .el-badge {
  margin: -10px 0 0 5px;
}

.reports .el-loading-mask {
  right: -40px;
  left: -40px;
}

</style>
